// Classic LCS-based line diff — fine for typical paste-sized text (not built for huge files).
export const diffLines = (textA, textB) => {
  const a = textA.split('\n')
  const b = textB.split('\n')
  const n = a.length
  const m = b.length

  const lcs = Array.from({ length: n + 1 }, () => new Array(m + 1).fill(0))
  for (let i = n - 1; i >= 0; i--) {
    for (let j = m - 1; j >= 0; j--) {
      lcs[i][j] =
        a[i] === b[j] ? lcs[i + 1][j + 1] + 1 : Math.max(lcs[i + 1][j], lcs[i][j + 1])
    }
  }

  const result = []
  let i = 0
  let j = 0
  while (i < n && j < m) {
    if (a[i] === b[j]) {
      result.push({ type: 'equal', value: a[i] })
      i++
      j++
    } else if (lcs[i + 1][j] >= lcs[i][j + 1]) {
      result.push({ type: 'removed', value: a[i] })
      i++
    } else {
      result.push({ type: 'added', value: b[j] })
      j++
    }
  }
  while (i < n) {
    result.push({ type: 'removed', value: a[i] })
    i++
  }
  while (j < m) {
    result.push({ type: 'added', value: b[j] })
    j++
  }
  return result
}

export const diffStats = (lines) => ({
  added: lines.filter((l) => l.type === 'added').length,
  removed: lines.filter((l) => l.type === 'removed').length,
})
